export default __webpack_public_path__ + "static/media/10k.95a83b02.gif";